import axios from 'axios'
import {apiUrl, qiniu, upload} from '@/api/base.js'

export default {
    get_tags(args) {
        return axios.get(`${apiUrl}v2/get_tags/`,{params:args})
    },
}
